import React, { useEffect, useState } from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import AddUserLayer from "../components/AddUserLayer";
import { Icon } from "@iconify/react/dist/iconify.js";
import Select from "react-select";
import { Link, useParams } from "react-router-dom";
import {  Button, Spinner } from "react-bootstrap";

import "react-bootstrap-typeahead/css/Typeahead.css";
import { API_URL } from "..";
import mapboxgl from "mapbox-gl";
import MapboxGeocoder from "@mapbox/mapbox-gl-geocoder";
import "@mapbox/mapbox-gl-geocoder/dist/mapbox-gl-geocoder.css";
import "mapbox-gl/dist/mapbox-gl.css";
import { Typeahead } from "react-bootstrap-typeahead";
import { useMapbox } from "../GoogleMapsContext";
import swal from "sweetalert";
import axios from "axios";
// import { useGoogleMaps } from "../GoogleMapsContext";
mapboxgl.accessToken = "pk.eyJ1IjoiemFtcCIsImEiOiJjbTkxa3dkcnMwMmQxMnJzYzBobW9hOHBiIn0.GWvvqPrWqtMby0HYCYdjMQ";

const containerStyle = {
  width: "100%",
  height: "300px",
};



const options = [
  { value: "Light Duty Towing", label: "Light Duty Towing" },
  { value: "Medium Duty Towing", label: "Medium Duty Towing" },
  { value: "Heavy Duty Towing", label: "Heavy Duty Towing" },
  { value: "Flatbed Towing", label: "Flatbed Towing" },
  { value: "Motorcycle Towing", label: "Motorcycle Towing" },
  { value: "Long-Distance Towing", label: "Long-Distance Towing" },
  { value: "Emergency Towing", label: "Emergency Towing" },
  { value: "Accident Recovery", label: "Accident Recovery" },
  { value: "Winch-Out Services", label: "Winch-Out Services" },
  { value: "Roadside Assistance", label: "Roadside Assistance" },
  { value: "Fuel Delivery", label: "Fuel Delivery" },
  { value: "Lockout Services", label: "Lockout Services" },
  { value: "Tire Change Services", label: "Tire Change Services" },
  { value: "Jump Start Services", label: "Jump Start Services" },
  { value: "Impound Towing", label: "Impound Towing" },
  { value: "Speciality Vehicle Towing", label: "Speciality Vehicle Towing" },
  { value: "Classic Car Towing", label: "Classic Car Towing" },
  { value: "Fleet Services", label: "Fleet Services" },
  { value: "Commercial Towing", label: "Commercial Towing" },
  {
    value: "Recreational Vehicle Towing",
    label: "Recreational Vehicle Towing",
  },
];

function formatDateToDDMMYYYY(dateString) {
  // Split the input string by '-'
  const [year, month, day] = dateString.split("-");
  
  // Ensure two digits for day and month by padding with zero if needed
  const formattedDay = day.padStart(2, "0");
  const formattedMonth = month.padStart(2, "0");
  
  // Return in DD/MM/YYYY format
  return `${formattedDay}/${formattedMonth}/${year}`;
}
const CreateInvoiceForJob = () => {
 
  const {id} = useParams();
  const [showAlertMessage, setshowAlertMessage] = useState({
    status: false,
    message: "",
    desc: "",
  });
  const [loading, setLoading] = useState(false);
  const [selectedOptionService, setSelectedOptionService] = useState([]);
  const [services, setServices] = useState([]);
  const [extraCosts, setExtraCosts] = useState([]);
  const [tax, setTax] = useState(0);
  const [discount, setDiscount] = useState(0);
  
  const [currentUser, setCurrentUser] = useState({});
  const [invoiceNumber, setInvoiceNumber] = useState("INV_");
  const [editingField, setEditingField] = useState(null); // Tracks the currently editing field
  const [invoiceData, setInvoiceData] = useState({
    invoiceNumber: "3492",
    issuedDate: "25/08/2020",
    dueDate: "29/08/2020",
    customerName: "Customer Name",
    customerAddress: "Type Address Here...",
    customerPhone: "Customer Phone...",
});

  
  
const startEditing = (field) => {
    setEditingField(field);
};

// Handle input change
const handleChange = (field, value) => {
    setInvoiceData({ ...invoiceData, [field]: value });
};

// Handle edit completion
const stopEditing = () => {
    setEditingField(null);
};

const fetchSingleJob = async ()=>{
    let headersList = {
        "Accept": "*/*",
        "Content-Type": "application/json"
      }
      let response = await fetch(`${API_URL}/api/job/affiliate/fetch-single/${id}`, { 
        method: "GET",
        headers: headersList
      });
      let data = await response.json();
      console.log(data)
      setInvoiceData((prev)=>({...prev, customerName : data?.data?.fullname , customerAddress :data?.data?.address , customerPhone : data?.data?.phone}))
}
  React.useEffect(() => {
    fetchSingleJob()
  }, [1]);

  const onFormSubmit = async (event) => {
    event.preventDefault();

    const formattedData = selectedOptionService.map((e) => e.value);
    if (selectedOptionService.length === 0) {
      setshowAlertMessage({
        message: "error",
        status: true,
        desc: "Select the service",
      });
      return false;
    }else if(currentUser.role === 'owner' && event.target.elements?.invoiceNumber?.value === 'INV_'){
      setshowAlertMessage({
        message: "error",
        status: true,
        desc: "Invoice number is required",
      });
    }
    
    else {
      setLoading(true)
      const invoiceItem = getInvoiceItems();
      let headersList = {
        Accept: "*/*",
        "Content-Type": "application/json",
      };
      const totalServiceCost = services.reduce(
        (sum, item) => sum + item.subtotal,
        0
      );
      const totalExtraCost = extraCosts.reduce((sum, item) => sum + item.amount, 0);
      const taxAmount = (totalServiceCost * tax) / 100;
      const discountAmount = (totalServiceCost * discount) / 100;
      const grandTotal =  totalServiceCost + totalExtraCost + taxAmount - discountAmount;
      let bodyContent = JSON.stringify({
        customer_name : invoiceData.customerName,
        phone: invoiceData.customerPhone,
        address: invoiceData.customerAddress,
        affiliate_id : currentUser?.id,
        invoiceNumber :event.target.elements?.invoiceNumber?.value,
        job_id: id,
        invoiceOurdueDate :formatDateToDDMMYYYY(event.target.elements?.invoiceOurdueDate?.value),
        invoiceItems: invoiceItem,
        tax:tax ,
        discount:discount,
        amount :grandTotal,
        
      });
      let response = await fetch(API_URL + "/api/job/affiliate/create-invoice", {
          method: "POST",
          body: bodyContent,
          headers: headersList,
        });
    
      let data = await response.json();
      setLoading(false)
      if (response.status == 201) {
        setshowAlertMessage({
          message: "success",
          status: true,
          desc: "Invoice is created successfully",
        });
      } else {
        setshowAlertMessage({
          message: "error",
          status: true,
          desc: "Error while created new invoice",
        });
      }
    }
  };
  
  const getCurrentUser = () => {
    const user = JSON.parse(localStorage.getItem("user"));
    if (user == null) {
      window.location.href = "/sign-in";
    } else {
      setCurrentUser(user);
    }
  };
  useEffect(() => {
    getCurrentUser();
  }, [1]);

 

 



  const handleChangeService = (selected) => {
    // Update the selected options
    setSelectedOptionService(selected);
  
    // Create a new services array by merging existing services with new selections
    const updatedServices = selected.map((newService) => {
      // Check if this service already exists in the current services array
      const existingService = services.find(
        (s) => s.value === newService.value
      );
  
      // If it exists, retain its qty, price, and subtotal; otherwise, initialize with defaults
      return existingService
        ? { ...newService, qty: existingService.qty, price: existingService.price, subtotal: existingService.subtotal }
        : { ...newService, qty: 1, price: 0, subtotal: 0 };
    });
  
    // Update the services state with the merged data
    setServices(updatedServices);
  };

  const handleQtyPriceChange = (index, field, value) => {
    const updatedServices = [...services];
    updatedServices[index][field] = Number(value);
    updatedServices[index].subtotal =
      updatedServices[index].qty * updatedServices[index].price;
    setServices(updatedServices);
  };

  const handleAddExtraCost = () => {
    setExtraCosts([...extraCosts, { name: "", amount: 0 }]);
  };

  const handleExtraCostChange = (index, field, value) => {
    const updatedCosts = [...extraCosts];
    updatedCosts[index][field] = field === "amount" ? Number(value) : value;
    setExtraCosts(updatedCosts);
  };

  const totalServiceCost = services.reduce(
    (sum, item) => sum + item.subtotal,
    0
  );
  const totalExtraCost = extraCosts.reduce((sum, item) => sum + item.amount, 0);
  const taxAmount = (totalServiceCost * tax) / 100;
  const discountAmount = (totalServiceCost * discount) / 100;
  const grandTotal =
    totalServiceCost + totalExtraCost + taxAmount - discountAmount;
  const getInvoiceItems = () => {
    const serviceItems = services.map((service) => ({
      item_name: service.label,
      quantity: service.qty,
      unit_price: service.price,
      price: service.subtotal,
    }));

    const extraCostItems = extraCosts.map((cost) => ({
      item_name: cost.name,
      quantity: 1,
      unit_price: cost.amount,
      price: cost.amount,
    }));

    return [...serviceItems, ...extraCostItems];
  };
  const handleRemoveExtraCost = (index) => {
    setExtraCosts(extraCosts.filter((_, i) => i !== index));
  };
  const handleChangeInvoice = (e) => {
    const value = e.target.value;
    // Ensure the value always starts with "INV_"
    if (!value.startsWith("INV_")) {
      setInvoiceNumber("INV_");
    } else {
      setInvoiceNumber(value); // Update with the full value including "INV_"
    }
  };
  
  


 
  
    return (
      <>
        {/* MasterLayout */}
       
        <MasterLayout>
          {/* Breadcrumb */}
          <Breadcrumb title="Add Job" />

          {/* AddUserLayer */}
          <div className="card h-100 p-0 radius-12">
            <div className="card-body p-24">
              <div className="row justify-content-center ">
                <div className="col-xxl-8 col-xl-8 col-lg-10">
                  <div className="card border">
                    <div className="card-body">
                      {/* Upload Image Start */}
                        
                      {/* Upload Image End */}
                      
                      
                                <div className="row justify-content-between g-3">
                                   
                                    <div className="col-sm-4">
                                        {
                                            currentUser.business_logo ? 
                                            <img style={{width:200}} src={API_URL+currentUser.business_logo}/>
                                            :
                                        <h6>{currentUser.business_name}</h6>
                                        }
                                        <p className="mb-1 text-sm">
                                            {currentUser.address}
                                        </p>
                                        <p className="mb-0 text-sm">{currentUser.email}</p>
                                        <p className="mb-0 text-sm">{currentUser.phone}</p>
                                    </div>
                            
                                  
                                </div>
                                <div className="mt-3">
                                        <h6 className="text-md">Issus For:</h6>
                                        <table className="text-sm text-secondary-light">
                                    <tbody>
                                        <tr>
                                            <td>Name</td>
                                            <td className="ps-8">
                                                :{" "}
                                                {editingField === "customerName" ? (
                                                    <input
                                                        type="text"
                                                        value={invoiceData.customerName}
                                                        onChange={(e) =>
                                                            handleChange("customerName", e.target.value)
                                                        }
                                                        onBlur={stopEditing}
                                                        className="editable-input"
                                                    />
                                                ) : (
                                                    <span
                                                        onClick={() => startEditing("customerName")}
                                                        className="editable text-decoration-underline"
                                                    >
                                                        {invoiceData.customerName}
                                                    </span>
                                                )}
                                                <span className="text-success-main">
                                                    <Icon
                                                        icon="mage:edit"
                                                        onClick={() => startEditing("customerName")}
                                                    />
                                                </span>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Address</td>
                                            <td className="ps-8">
                                                :{" "}
                                                {editingField === "customerAddress" ? (
                                                    <input
                                                        type="text"
                                                        value={invoiceData.customerAddress}
                                                        onChange={(e) =>
                                                            handleChange("customerAddress", e.target.value)
                                                        }
                                                        onBlur={stopEditing}
                                                        className="editable-input"
                                                    />
                                                ) : (
                                                    <span
                                                        onClick={() => startEditing("customerAddress")}
                                                        className="editable text-decoration-underline"
                                                    >
                                                        {invoiceData.customerAddress}
                                                    </span>
                                                )}
                                                <span className="text-success-main">
                                                    <Icon
                                                        icon="mage:edit"
                                                        onClick={() => startEditing("customerAddress")}
                                                    />
                                                </span>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Phone number</td>
                                            <td className="ps-8">
                                                :{" "}
                                                {editingField === "customerPhone" ? (
                                                    <input
                                                        type="text"
                                                        value={invoiceData.customerPhone}
                                                        onChange={(e) =>
                                                            handleChange("customerPhone", e.target.value)
                                                        }
                                                        onBlur={stopEditing}
                                                        className="editable-input"
                                                    />
                                                ) : (
                                                    <span
                                                        onClick={() => startEditing("customerPhone")}
                                                        className="editable text-decoration-underline"
                                                    >
                                                        {invoiceData.customerPhone}
                                                    </span>
                                                )}
                                                <span className="text-success-main">
                                                    <Icon
                                                        icon="mage:edit"
                                                        onClick={() => startEditing("customerPhone")}
                                                    />
                                                </span>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                                    </div>
                                   
                      
                      <form onSubmit={(event) => onFormSubmit(event)}>
                       
                        <div className="container mt-5 p-4  rounded  bg-white">
                          <div className="mb-3">
                        
                            <label className="form-label fw-semibold">
                              Select Services{" "}
                            </label>
                              <Select
                                options={options}
                                isMulti
                                value={selectedOptionService}
                                onChange={handleChangeService}
                                placeholder="Select Services"
                              />
                            </div>

                            {services.length > 0 && (
                              <table className="table table-bordered mt-4">
                                <thead className="table-dark">
                                  <tr>
                                    <th>Service</th>
                                    <th>Quantity</th>
                                    <th>Price</th>
                                    <th>Subtotal</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {services.map((service, index) => (
                                    <tr key={service.value}>
                                      <td>{service.label}</td>
                                      <td>
                                        <input
                                          className="form-control"
                                          type="number"
                                          min="1"
                                          value={service.qty}
                                          onChange={(e) =>
                                            handleQtyPriceChange(
                                              index,
                                              "qty",
                                              e.target.value
                                            )
                                          }
                                        />
                                      </td>
                                      <td>
                                        <input
                                          className="form-control"
                                          type="number"
                                          min="0"
                                          value={service.price}
                                          onChange={(e) =>
                                            handleQtyPriceChange(
                                              index,
                                              "price",
                                              e.target.value
                                            )
                                          }
                                        />
                                      </td>
                                      <td>${service.subtotal.toFixed(2)}</td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            )}

                          <button
                            type="button"
                            className="btn btn-primary mt-3"
                            onClick={handleAddExtraCost}
                          >
                            + Add Extra Cost
                          </button>

                          {extraCosts.length > 0 && (
                            <table className="table table-bordered mt-3">
                              <thead className="table-secondary">
                                <tr>
                                  <th>Extra Cost Name</th>
                                  <th>Amount</th>
                                  <th>Action</th>
                                </tr>
                              </thead>
                              <tbody>
                                {extraCosts.map((cost, index) => (
                                  <tr key={index}>
                                    <td>
                                      <input
                                        className="form-control"
                                        type="text"
                                        placeholder="Cost Name"
                                        value={cost.name}
                                        onChange={(e) =>
                                          handleExtraCostChange(
                                            index,
                                            "name",
                                            e.target.value
                                          )
                                        }
                                      />
                                    </td>
                                    <td>
                                      <input
                                        className="form-control"
                                        type="number"
                                        min="0"
                                        placeholder="Amount"
                                        value={cost.amount}
                                        onChange={(e) =>
                                          handleExtraCostChange(
                                            index,
                                            "amount",
                                            e.target.value
                                          )
                                        }
                                      />
                                    </td>
                                    <td>
                                      <Button
                                        type="button"
                                        onClick={() =>
                                          handleRemoveExtraCost(index)
                                        }
                                        className="btn btn-danger"
                                      >
                                        X
                                      </Button>
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          )}

                          <div className="row mt-3 mb-3">
                          <div className="col-md-4">
                          <label htmlFor="invoiceNumber" className="form-label fw-semibold">
                            Invoice Number
                          </label>
                          <input
                            className="form-control"
                            type="text"
                            name="invoiceNumber"
                            id="invoiceNumber"
                            value={invoiceNumber}
                            onChange={handleChangeInvoice}
                            placeholder="INV_12345"
                          />
                        </div>
                            <div className="col-md-4">
                            
                              <label htmlFor="invoiceOurdueDate" className="form-label fw-semibold">
                               Overdue Date
                              </label>
                              <input
                                className="form-control"
                                type="date"
                                name="invoiceOurdueDate"
                                min="0"
                               
                              />
                            </div>
                            <div className="col-md-2">
                            
                              <label className="form-label fw-semibold">
                                Tax (%)
                              </label>
                              <input
                                className="form-control"
                                type="number"
                                min="0"
                                value={tax}
                                onChange={(e) => setTax(Number(e.target.value))}
                              />
                            </div>
                            <div className="col-md-2">
                              <label className="form-label fw-semibold">
                                Dis (%)
                              </label>
                              <input
                                className="form-control"
                                type="number"
                                min="0"
                                value={discount}
                                onChange={(e) =>
                                  setDiscount(Number(e.target.value))
                                }
                              />
                            </div>
                          </div>

                          <table className="table table-bordered mt-4">
                            <tbody>
                              <tr>
                                <td className="fw-semibold">Service Total</td>
                                <td>${totalServiceCost.toFixed(2)}</td>
                              </tr>
                              <tr>
                                <td className="fw-semibold">Extra Costs</td>
                                <td>${totalExtraCost.toFixed(2)}</td>
                              </tr>
                              <tr>
                                <td className="fw-semibold">Tax</td>
                                <td>${taxAmount.toFixed(2)}</td>
                              </tr>
                              <tr>
                                <td className="fw-semibold">Discount</td>
                                <td>-${discountAmount.toFixed(2)}</td>
                              </tr>
                              <tr className="table-success">
                                <td className="fw-bold fs-5">Grand Total</td>
                                <td className="fw-bold fs-5">
                                  ${grandTotal.toFixed(2)}
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>

                        {showAlertMessage.status === true ? (
                          <div
                            className={
                              showAlertMessage.message == "error"
                                ? "alert alert-danger bg-danger-50 text-danger-600 border-danger-50 px-24 py-11 mb-0 fw-semibold text-lg radius-8 d-flex align-items-center justify-content-between mb-10"
                                : "alert alert-success bg-success-50 text-success-600 border-success-50 px-24 py-11 mb-0 fw-semibold text-lg radius-8 d-flex align-items-center justify-content-between mb-10"
                            }
                            role="alert"
                          >
                            {showAlertMessage.desc}
                            <button
                              type="button"
                              onClick={() =>
                                setshowAlertMessage(!showAlertMessage)
                              }
                              className="remove-button text-secondary-600 text-xxl line-height-1"
                            >
                              {" "}
                              <Icon
                                icon="iconamoon:sign-times-light"
                                className="icon"
                              />
                            </button>
                          </div>
                        ) : null}
                        
                        <div className="d-flex align-items-center justify-content-center gap-3">
                         {
                          loading === true ?
                          <Spinner/>:
                          <button
                            type="submit"
                            className="btn btn-primary border border-primary-600 text-md px-56 py-12 radius-8"
                          >
                            Save
                          </button>
                         }
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </MasterLayout>
        
      </>
    );
  
};

export default CreateInvoiceForJob;
